import {EVENTS} from '../config/boCore';
import DataViewConfiguration from '../views/bo-core/DataViewConfiguration';
import {Instance} from '../components/bo-core/models/Instance';
import {BusinessObject} from '../components/bo-core/models/BusinessObject';
import {BusinessObjectsWrapper} from '../components/bo-core/models/BusinessObjectsWrapper';
import moment from "moment";
import {Attribute} from "../components/bo-core/models/Attribute";
import {AttributeTypeEnum} from "../components/bo-core/enums/AttributeTypeEnum";
import {Relationship} from "../components/bo-core/models/Relationship";
import {DataViewWrapper} from "../components/bo-core/models/DataViewWrapper";
import {AttributeInterface} from "../components/bo-core/Interfaces/AttributeInterface";
import Utils from "../Utils";
import {DataViewInterface} from "../components/bo-core/Interfaces/DataViewInterface";

export const actions = {

    /** Business Objects Actions */
    FETCH_ALL_BUSINESS_OBJECTS_PENDING: 'FETCH_ALL_BUSINESS_OBJECTS_PENDING',
    FETCH_ALL_BUSINESS_OBJECTS_DISPATCH_SUCCESS: 'FETCH_ALL_BUSINESS_OBJECTS_DISPATCH_SUCCESS',
    FETCH_ALL_BUSINESS_OBJECTS_DISPATCH_ERROR: 'FETCH_ALL_BUSINESS_OBJECTS_DISPATCH_ERROR',

    CREATE_BUSINESS_OBJECT_RECORD_PENDING: 'CREATE_BUSINESS_OBJECT_RECORD_PENDING',
    CREATE_BUSINESS_OBJECT_RECORD_DISPATCH_SUCCESS: 'CREATE_BUSINESS_OBJECT_RECORD_DISPATCH_SUCCESS',
    CREATE_BUSINESS_OBJECT_RECORD_DISPATCH_ERROR: 'CREATE_BUSINESS_OBJECT_RECORD_DISPATCH_ERROR',

    UPDATE_BUSINESS_OBJECT_RECORD_PENDING: 'UPDATE_BUSINESS_OBJECT_RECORD_PENDING',
    UPDATE_BUSINESS_OBJECT_RECORD_DISPATCH_SUCCESS: 'UPDATE_BUSINESS_OBJECT_RECORD_DISPATCH_SUCCESS',
    UPDATE_BUSINESS_OBJECT_RECORD_DISPATCH_ERROR: 'UPDATE_BUSINESS_OBJECT_RECORD_DISPATCH_ERROR',

    UPDATE_UNIQUE_NAME_ATTRIBUTE_PENDING: 'UPDATE_UNIQUE_NAME_ATTRIBUTE_PENDING',
    UPDATE_UNIQUE_NAME_ATTRIBUTE_DISPATCH_SUCCESS: 'UPDATE_UNIQUE_NAME_ATTRIBUTE_DISPATCH_SUCCESS',
    UPDATE_UNIQUE_NAME_ATTRIBUTE_DISPATCH_ERROR: 'UPDATE_UNIQUE_NAME_ATTRIBUTE_DISPATCH_ERROR',

    DELETE_BUSINESS_OBJECT_RECORD_PENDING: 'DELETE_BUSINESS_OBJECT_RECORD_PENDING',
    DELETE_BUSINESS_OBJECT_RECORD_DISPATCH_SUCCESS: 'DELETE_BUSINESS_OBJECT_RECORD_DISPATCH_SUCCESS',
    DELETE_BUSINESS_OBJECT_RECORD_DISPATCH_ERROR: 'DELETE_BUSINESS_OBJECT_RECORD_DISPATCH_ERROR',

    CREATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING: 'CREATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING',
    CREATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS: 'CREATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS',
    CREATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR: 'CREATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR',

    UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING: 'UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING',
    UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS: 'UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS',
    UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR: 'UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR',

    DELETE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING: 'DELETE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING',
    DELETE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS: 'DELETE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS',
    DELETE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR: 'DELETE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR',

    CREATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_PENDING: 'CREATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_PENDING',
    CREATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_SUCCESS: 'CREATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_SUCCESS',
    CREATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_ERROR: 'CREATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_ERROR',

    UPDATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_PENDING: 'UPDATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_PENDING',
    UPDATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_SUCCESS: 'UPDATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_SUCCESS',
    UPDATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_ERROR: 'UPDATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_ERROR',

    DELETE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_PENDING: 'DELETE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_PENDING',
    DELETE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_SUCCESS: 'DELETE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_SUCCESS',
    DELETE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_ERROR: 'DELETE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_ERROR',

    CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_PENDING: 'CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_PENDING',
    CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_SUCCESS: 'CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_SUCCESS',
    CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_ERROR: 'CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_ERROR',

    UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_PENDING: 'UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_PENDING',
    UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_SUCCESS: 'UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_SUCCESS',
    UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_ERROR: 'UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_ERROR',

    DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_PENDING: 'DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_PENDING',
    DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_SUCCESS: 'DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_SUCCESS',
    DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_ERROR: 'DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_ERROR',

    /** Instance Actions */
    FETCH_ALL_BOC_INSTANCES_PENDING: 'FETCH_ALL_BOC_INSTANCES_PENDING',
    FETCH_ALL_BOC_INSTANCES_DISPATCH_SUCCESS: 'FETCH_ALL_BOC_INSTANCES_DISPATCH_SUCCESS',
    FETCH_ALL_BOC_INSTANCES_DISPATCH_ERROR: 'FETCH_ALL_BOC_INSTANCES_DISPATCH_ERROR',

    FETCH_BO_INSTANCE_BY_ID_PENDING: 'FETCH_BO_INSTANCE_BY_ID_PENDING',
    FETCH_BO_INSTANCE_BY_ID_DISPATCH_SUCCESS: 'FETCH_BO_INSTANCE_BY_ID_DISPATCH_SUCCESS',
    FETCH_BO_INSTANCE_BY_ID_DISPATCH_ERROR: 'FETCH_BO_INSTANCE_BY_ID_DISPATCH_ERROR',

    CREATE_BO_INSTANCE_PENDING: 'CREATE_BO_INSTANCE_PENDING',
    CREATE_BO_INSTANCE_DISPATCH_SUCCESS: 'CREATE_BO_INSTANCE_DISPATCH_SUCCESS',
    CREATE_BO_INSTANCE_DISPATCH_ERROR: 'CREATE_BO_INSTANCE_DISPATCH_ERROR',

    UPDATE_BO_INSTANCE_PENDING: 'UPDATE_BO_INSTANCE_PENDING',
    UPDATE_BO_INSTANCE_DISPATCH_SUCCESS: 'UPDATE_BO_INSTANCE_DISPATCH_SUCCESS',
    UPDATE_BO_INSTANCE_DISPATCH_ERROR: 'UPDATE_BO_INSTANCE_DISPATCH_ERROR',

    CREATE_BO_INSTANCE_LAYOUT_PENDING: 'CREATE_BO_INSTANCE_LAYOUT_PENDING',
    CREATE_BO_INSTANCE_LAYOUT_DISPATCH_SUCCESS: 'CREATE_BO_INSTANCE_LAYOUT_DISPATCH_SUCCESS',
    CREATE_BO_INSTANCE_LAYOUT_DISPATCH_ERROR: 'CREATE_BO_INSTANCE_LAYOUT_DISPATCH_ERROR',

    UPDATE_BO_INSTANCE_LAYOUT_PENDING: 'UPDATE_BO_INSTANCE_LAYOUT_PENDING',
    UPDATE_BO_INSTANCE_LAYOUT_DISPATCH_SUCCESS: 'UPDATE_BO_INSTANCE_LAYOUT_DISPATCH_SUCCESS',
    UPDATE_BO_INSTANCE_LAYOUT_DISPATCH_ERROR: 'UPDATE_BO_INSTANCE_LAYOUT_DISPATCH_ERROR',

    CREATE_BO_INSTANCE_RELATIONSHIP_PENDING: 'CREATE_BO_INSTANCE_RELATIONSHIP_PENDING',
    CREATE_BO_INSTANCE_RELATIONSHIP_DISPATCH_SUCCESS: 'CREATE_BO_INSTANCE_RELATIONSHIP_DISPATCH_SUCCESS',
    CREATE_BO_INSTANCE_RELATIONSHIP_DISPATCH_ERROR: 'CREATE_BO_INSTANCE_RELATIONSHIP_DISPATCH_ERROR',

    DELETE_BO_INSTANCE_RELATIONSHIP_PENDING: 'DELETE_BO_INSTANCE_RELATIONSHIP_PENDING',
    DELETE_BO_INSTANCE_RELATIONSHIP_DISPATCH_SUCCESS: 'DELETE_BO_INSTANCE_RELATIONSHIP_DISPATCH_SUCCESS',
    DELETE_BO_INSTANCE_RELATIONSHIP_DISPATCH_ERROR: 'DELETE_BO_INSTANCE_RELATIONSHIP_DISPATCH_ERROR',

    UPDATE_BO_INSTANCE_TAGS_PENDING: 'UPDATE_BO_INSTANCE_TAGS_PENDING',
    UPDATE_BO_INSTANCE_TAGS_DISPATCH_SUCCESS: 'UPDATE_BO_INSTANCE_TAGS_DISPATCH_SUCCESS',
    UPDATE_BO_INSTANCE_TAGS_DISPATCH_ERROR: 'UPDATE_BO_INSTANCE_TAGS_DISPATCH_ERROR',

    DELETE_BO_INSTANCE_PENDING: 'DELETE_BO_INSTANCE_PENDING',
    DELETE_BO_INSTANCE_DISPATCH_SUCCESS: 'DELETE_BO_INSTANCE_DISPATCH_SUCCESS',
    DELETE_BO_INSTANCE_DISPATCH_ERROR: 'DELETE_BO_INSTANCE_DISPATCH_ERROR',

    SET_CURRENT_INSTANCE: "SET_CURRENT_INSTANCE",
    SET_ORIGINAL_INSTANCE: "SET_ORIGINAL_INSTANCE",

    /** Data View Actions */
    CREATE_DATA_VIEW_PENDING: 'CREATE_DATA_VIEW_PENDING',
    CREATE_DATA_VIEW_DISPATCH_SUCCESS: 'CREATE_DATA_VIEW_DISPATCH_SUCCESS',
    CREATE_DATA_VIEW_DISPATCH_ERROR: 'CREATE_DATA_VIEW_DISPATCH_ERROR',

    CLONE_DATA_VIEW_PENDING: 'CLONE_DATA_VIEW_PENDING',
    CLONE_DATA_VIEW_DISPATCH_SUCCESS: 'CLONE_DATA_VIEW_DISPATCH_SUCCESS',
    CLONE_DATA_VIEW_DISPATCH_ERROR: 'CLONE_DATA_VIEW_DISPATCH_ERROR',

    UPDATE_DATA_VIEW_PENDING: 'UPDATE_DATA_VIEW_PENDING',
    UPDATE_DATA_VIEW_DISPATCH_SUCCESS: 'UPDATE_DATA_VIEW_DISPATCH_SUCCESS',
    UPDATE_DATA_VIEW_DISPATCH_ERROR: 'UPDATE_DATA_VIEW_DISPATCH_ERROR',

    DELETE_DATA_VIEW_PENDING: 'DELETE_DATA_VIEW_PENDING',
    DELETE_DATA_VIEW_DISPATCH_SUCCESS: 'DELETE_DATA_VIEW_DISPATCH_SUCCESS',
    DELETE_DATA_VIEW_DISPATCH_ERROR: 'DELETE_DATA_VIEW_DISPATCH_ERROR',

    FETCH_ALL_DATA_VIEWS_PENDING: 'FETCH_ALL_DATA_VIEWS_PENDING',
    FETCH_ALL_DATA_VIEWS_DISPATCH_SUCCESS: 'FETCH_ALL_DATA_VIEWS_DISPATCH_SUCCESS',
    FETCH_ALL_DATA_VIEWS_DISPATCH_ERROR: 'FETCH_ALL_DATA_VIEWS_DISPATCH_ERROR',

    FETCH_ALL_DATA_VIEWS_BY_BOC_ID_PENDING: 'FETCH_ALL_DATA_VIEWS_BY_BOC_ID_PENDING',
    FETCH_ALL_DATA_VIEWS_BY_BOC_ID_SUCCESS: 'FETCH_ALL_DATA_VIEWS_BY_BOC_ID_SUCCESS',
    FETCH_ALL_DATA_VIEWS_BY_BOC_ID_ERROR: 'FETCH_ALL_DATA_VIEWS_BY_BOC_ID_ERROR',

    CREATE_COLUMNS_OF_DATA_VIEW_PENDING: 'CREATE_COLUMNS_OF_DATA_VIEW_PENDING',
    CREATE_COLUMNS_OF_DATA_VIEW_DISPATCH_SUCCESS: 'CREATE_COLUMNS_OF_DATA_VIEW_DISPATCH_SUCCESS',
    CREATE_COLUMNS_OF_DATA_VIEW_DISPATCH_ERROR: 'CREATE_COLUMNS_OF_DATA_VIEW_DISPATCH_ERROR',

    SET_CURRENT_DATA_VIEW: "SET_CURRENT_DATA_VIEW",

    FETCH_ALL_TAGS_PENDING: 'FETCH_ALL_TAGS_PENDING',
    FETCH_ALL_TAGS_DISPATCH_SUCCESS: 'FETCH_ALL_TAGS_DISPATCH_SUCCESS',
    FETCH_ALL_TAGS_DISPATCH_ERROR: 'FETCH_ALL_TAGS_DISPATCH_ERROR',
    /** Layout Actions */
    FETCH_ALL_BOC_LAYOUTS_PENDING: "FETCH_ALL_BOC_LAYOUTS_PENDING",
    FETCH_ALL_BOC_LAYOUTS_SUCCESS: "FETCH_ALL_BOC_LAYOUTS_SUCCESS",
    FETCH_ALL_BOC_LAYOUTS_ERROR: "FETCH_ALL_BOC_LAYOUTS_ERROR",

    CREATE_BOC_LAYOUT_PENDING: "CREATE_BOC_LAYOUT_PENDING",
    CREATE_BOC_LAYOUT_SUCCESS: "CREATE_BOC_LAYOUT_SUCCESS",
    CREATE_BOC_LAYOUT_ERROR: "CREATE_BOC_LAYOUT_ERROR",

    FETCH_BOC_LAYOUT_BY_ID_PENDING: "FETCH_BOC_LAYOUT_BY_ID_PENDING",
    FETCH_BOC_LAYOUT_BY_ID_SUCCESS: "FETCH_BOC_LAYOUT_BY_ID_SUCCESS",
    FETCH_BOC_LAYOUT_BY_ID_ERROR: "FETCH_BOC_LAYOUT_BY_ID_ERROR",

    UPDATE_BOC_LAYOUT_BY_ID_PENDING: "UPDATE_BOC_LAYOUT_BY_ID_PENDING",
    UPDATE_BOC_LAYOUT_BY_ID_SUCCESS: "UPDATE_BOC_LAYOUT_BY_ID_SUCCESS",
    UPDATE_BOC_LAYOUT_BY_ID_ERROR: "UPDATE_BOC_LAYOUT_BY_ID_ERROR",

    DELETE_BOC_LAYOUT_BY_ID_PENDING: "DELETE_BOC_LAYOUT_BY_ID_PENDING",
    DELETE_BOC_LAYOUT_BY_ID_SUCCESS: "DELETE_BOC_LAYOUT_BY_ID_SUCCESS",
    DELETE_BOC_LAYOUT_BY_ID_ERROR: "DELETE_BOC_LAYOUT_BY_ID_ERROR",

    SET_CURRENT_BOC_LAYOUT: "SET_CURRENT_BOC_LAYOUT",

    SET_HIDDEN_AND_MODIFIED_BOCS_FOR_LAYOUT: "SET_HIDDEN_AND_MODIFIED_BOCS_FOR_LAYOUT",
    UPDATE_BOC_IN_LAYOUT: "UPDATE_BOC_IN_LAYOUT",

    LAYOUT_SAVE_OBJECTS_PENDING: "LAYOUT_SAVE_OBJECTS_PENDING",
    LAYOUT_SAVE_OBJECTS_SUCCESS: "LAYOUT_SAVE_OBJECTS_SUCCESS",
    LAYOUT_SAVE_OBJECTS_ERROR: "LAYOUT_SAVE_OBJECTS_ERROR",

    FETCH_PARTS_TO_COMPARE_PENDING: "FETCH_PARTS_TO_COMPARE_PENDING",
    FETCH_PARTS_TO_COMPARE_DISPATCH_SUCCESS: "FETCH_PARTS_TO_COMPARE_DISPATCH_SUCCESS",
    FETCH_PARTS_TO_COMPARE_DISPATCH_ERROR: "FETCH_PARTS_TO_COMPARE_DISPATCH_ERROR",

    DELETE_BO_INSTANCES_PENDING: "DELETE_BO_INSTANCES_PENDING",
    DELETE_BO_INSTANCES_DISPATCH_SUCCESS: "DELETE_BO_INSTANCES_DISPATCH_SUCCESS",
    DELETE_BO_INSTANCES_DISPATCH_ERROR: "DELETE_BO_INSTANCES_DISPATCH_ERROR"
};

export default (state =
                    {
                        tagsSet: <Set<string>>null,
                        dataViewsWrapper: <DataViewWrapper>null,
                        businessObjectsWrapper: <BusinessObjectsWrapper>null,

                        createColumnsOfDataViewUpdateFlag: false,
                        columnsOfDataViewAreBeingCRUD: false,

                        allLayouts: null,

                        currentLayout: null,

                        hiddenAndModifiedBOCsForLayout: [],
                        updateBOCsInLayout: [],
                        allBOCreated: false,
                        allTypes: null,
                        currentDataView: <DataViewInterface>null

                    }, action) => {

    state = {...state};

    switch (action.type) {

        //FETCH_ALL_BUSINESS_OBJECTS ........................................................................
        case actions.FETCH_ALL_BUSINESS_OBJECTS_PENDING:
            state.allTypes = null;
            state.businessObjectsWrapper = null;
            return state;
        case actions.FETCH_ALL_BUSINESS_OBJECTS_DISPATCH_SUCCESS: {
            const businessObjects = [];

            action.payload.forEach((bo) => {
                const findBusinessObjectById = (id: number) => {
                    return action.payload.find(bo => {
                        return bo.id === id;
                    })
                };

                const getModifiedRelationships = () => {
                    bo.relationships.forEach(rel => {
                        if (rel.fromBoClassId === bo.id) {
                            rel['fromBoClass'] = {
                                id: bo.id,
                                name: bo.name,
                                description: bo.description
                            };
                            const relatedObject = findBusinessObjectById(rel.toBoClassId);
                            if (relatedObject) {
                                rel['toBoClass'] = {
                                    id: relatedObject.id,
                                    name: relatedObject.name,
                                    description: relatedObject.description
                                };
                            }
                        } else if (rel.toBoClassId === bo.id) {
                            rel['toBoClass'] = {
                                id: bo.id,
                                name: bo.name,
                                description: bo.description
                            };
                            const relatedObject = findBusinessObjectById(rel.fromBoClassId);
                            if (relatedObject) {
                                rel['fromBoClass'] = {
                                    id: relatedObject.id,
                                    name: relatedObject.name,
                                    description: relatedObject.description
                                };
                            }
                        }
                    })

                    return bo.relationships;
                };

                bo.attributes.forEach(attrib => {
                    switch (attrib.type) {
                        case AttributeTypeEnum.TIME:
                            const dataTime = `${moment().format("YYYY-MM-DD")} ${action.payload.defaultValue}`;
                            action.payload.defaultValue = moment(dataTime, moment.ISO_8601).isValid() ? moment.utc(dataTime).utcOffset(moment(dataTime).format("ZZ").toString()).format('HH:mm:ss') : action.payload.defaultValue;
                            break;
                        case AttributeTypeEnum.TIMESTAMP:
                            attrib.defaultValue = moment.utc(attrib.defaultValue).utcOffset(moment(attrib.defaultValue).format("ZZ").toString()).format(moment(attrib.defaultValue).creationData().format.toString());
                            break;
                        case AttributeTypeEnum.EMAIL:
                            attrib.defaultValue = Utils.parseEmailAttributeDefaultValue(attrib.defaultValue, attrib.attributeValues);
                            break;
                    }

                    // All these changes, because of the changed DTO of v2 API
                    attrib['unitOfMeasure'] = attrib.uom;
                    attrib['type'] = attrib.atrbType;
                    attrib['required'] = attrib.isRequired;
                });

                const relationships = getModifiedRelationships();
                const nameAttribute = bo.attributes.find(attribute => {
                    return attribute.name === 'Name';
                });
                let isNameUnique = nameAttribute ? nameAttribute.unique : null;
                businessObjects.push(new BusinessObject(bo.id, bo.name, bo.description, bo.instancesCount, bo.tags, bo.attributes, relationships, bo.systemRequired, bo.inferenceTemp, isNameUnique));
            });
            state.allTypes = action.payload;
            state.businessObjectsWrapper = new BusinessObjectsWrapper(businessObjects);
        }
            return state;
        case actions.FETCH_ALL_BUSINESS_OBJECTS_DISPATCH_ERROR:
            state.allTypes = null;
            state.businessObjectsWrapper = <BusinessObjectsWrapper>null;
            return state;
        //...................................................................................................

        //CREATE_BUSINESS_OBJECT_RECORD......................................................................
        case actions.CREATE_BUSINESS_OBJECT_RECORD_PENDING:
            return state;
        case actions.CREATE_BUSINESS_OBJECT_RECORD_DISPATCH_SUCCESS: {
            action.payload.relationshipTypes.forEach(rel => {
                const businessObject = state.businessObjectsWrapper.getBusinessObject(rel.fromBoClass.id);
                businessObject.addRelationship(new Relationship(rel.id, rel.name, rel.inward, rel.outward, rel.fromBoClass, rel.toBoClass, rel.systemRequired));
            });
            const nameAttribute = action.payload.attributes.find(attribute => {
                return attribute.name === 'Name';
            });
            const isNameUnique = nameAttribute ? nameAttribute.unique : null;
            state.businessObjectsWrapper.addBusinessObject(new BusinessObject(action.payload.id, action.payload.name,
                action.payload.description, 0, [], action.payload.attributes,
                action.payload.relationshipTypes, action.payload.systemRequired, action.payload.inferenceTemp, isNameUnique));
            state.hiddenAndModifiedBOCsForLayout = [];
            switch (action.args.event) {
                case EVENTS.boView.typesGrid.create: {
                    Utils.eventDispatcher(action.args.event, {
                        data: state.businessObjectsWrapper,
                        withNewRow: action.args.withNewRow,
                        id: action.payload.id,
                    });
                }
            }
        }
            return state;
        case actions.CREATE_BUSINESS_OBJECT_RECORD_DISPATCH_ERROR:
            return state;
        //............................................................................................................

        //UPDATE_BUSINESS_OBJECT_RECORD...............................................................................
        case actions.UPDATE_BUSINESS_OBJECT_RECORD_PENDING:
            return state;
        case actions.UPDATE_BUSINESS_OBJECT_RECORD_DISPATCH_SUCCESS: {
            action.payload.attributes.forEach(attrib => {
                switch (attrib.type) {
                    case AttributeTypeEnum.TIME:
                        attrib.defaultValue = moment.utc(`1970-01-01 ${attrib.defaultValue}`).utcOffset(moment(`1970-01-01 ${attrib.defaultValue}`).format("ZZ").toString()).format("HH:mm:ss");
                        break;
                    case AttributeTypeEnum.TIMESTAMP:
                        attrib.defaultValue = moment.utc(attrib.defaultValue).utcOffset(moment(attrib.defaultValue).format("ZZ").toString()).format(moment(attrib.defaultValue).creationData().format.toString());
                        break;
                }
            });
            const nameAttribute = action.payload.attributes.find(attribute => {
                return attribute.name === 'Name';
            });
            const isNameUnique = nameAttribute ? nameAttribute.unique : null;
            state.businessObjectsWrapper.updateBusinessObject(new BusinessObject(action.payload.id, action.payload.name,
                action.payload.description, action.payload.instancesCount, action.payload.tags, action.payload.attributes,
                action.payload.relationshipTypes, action.payload.systemRequired, action.payload.inferenceTemp, isNameUnique));
            state.hiddenAndModifiedBOCsForLayout = [];
            switch (action.args.event) {
                case EVENTS.boView.typesGrid.update: {
                    Utils.eventDispatcher(action.args.event, {
                        businessObject: state.businessObjectsWrapper.getBusinessObject(action.payload.id)
                    });
                }
            }
        }
            return state;
        case actions.UPDATE_BUSINESS_OBJECT_RECORD_DISPATCH_ERROR:
            return state;
        //...............................................................................................................

        //UPDATE_UNIQUE_NAME_ATTRIBUTE...................................................................................
        case actions.UPDATE_UNIQUE_NAME_ATTRIBUTE_PENDING:
            return state;
        case actions.UPDATE_UNIQUE_NAME_ATTRIBUTE_DISPATCH_SUCCESS: {
            state.businessObjectsWrapper.updateBusinessObject(new BusinessObject(action.payload.id, action.payload.name,
                action.payload.description, action.payload.instancesCount, action.payload.tags, action.payload.attributes,
                action.payload.relationshipTypes, action.payload.systemRequired, action.payload.inferenceTemp, action.payload.uniqueName));
            state.hiddenAndModifiedBOCsForLayout = [];
            switch (action.args.event) {
                case EVENTS.boView.typesGrid.update: {
                    Utils.eventDispatcher(action.args.event, {
                        businessObject: state.businessObjectsWrapper.getBusinessObject(action.payload.id)
                    });
                }
            }
        }
            return state;
        case actions.UPDATE_UNIQUE_NAME_ATTRIBUTE_DISPATCH_ERROR:
            return state;
        //...............................................................................................................

        //DELETE_BUSINESS_OBJECT_RECORD..................................................................................
        case actions.DELETE_BUSINESS_OBJECT_RECORD_PENDING:
            return state;
        case actions.DELETE_BUSINESS_OBJECT_RECORD_DISPATCH_SUCCESS:
            state.businessObjectsWrapper.deleteBusinessObject(action.payload.id);
            state.hiddenAndModifiedBOCsForLayout = [];
            switch (action.args.event) {
                case EVENTS.boView.typesGrid.delete: {
                    Utils.eventDispatcher(action.args.event, {
                        id: action.payload.id,
                        businessObjectsWrapper: state.businessObjectsWrapper
                    });
                }
            }
            return state;
        case actions.DELETE_BUSINESS_OBJECT_RECORD_DISPATCH_ERROR:
            return state;
        //......................................................................................................................

        //CREATE_BUSINESS_OBJECT_ATTRIBUTE......................................................................................
        case actions.CREATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING:
            return state;
        case actions.CREATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS: {
            switch (action.payload.type) {
                case AttributeTypeEnum.TIMESTAMP:
                    action.payload.defaultValue = moment(action.payload.defaultValue, moment.ISO_8601).isValid() ? moment.utc(action.payload.defaultValue).utcOffset(moment(action.payload.defaultValue).format("ZZ").toString()).format(moment(action.payload.defaultValue).creationData().format.toString()) : action.payload.defaultValue;
                    break;
                case AttributeTypeEnum.TIME:
                    const dataTime = `${moment().format("YYYY-MM-DD")} ${action.payload.defaultValue}`;
                    action.payload.defaultValue = moment(dataTime, moment.ISO_8601).isValid() ? moment.utc(dataTime).utcOffset(moment(dataTime).format("ZZ").toString()).format('HH:mm:ss') : action.payload.defaultValue;
                    break;
            }
            const businessObject = state.businessObjectsWrapper.getBusinessObject(action.args.boClass.id);
            businessObject.addAttribute(new Attribute(action.payload.id, action.payload.name, action.payload.description, action.payload.unitOfMeasure, action.payload.type, action.payload.minLength, action.payload.maxLength, action.payload.maxDigitsLeftOfDecimal, action.payload.minDigitsRightOfDecimal, action.payload.regexValidation, action.payload.uiSection, action.payload.prefix, action.payload.suffix, action.payload.receiveNotifications, {
                id: businessObject.id,
                name: businessObject.name,
                description: businessObject.description
            }, action.payload.attributeValues, action.payload.required, action.payload.systemRequired, action.payload.defaultValue, action.payload.lookupAttributeId, action.payload.createRelationships, action.payload.lookupRelTypeId));
            switch (action.args.event) {
                case EVENTS.boView.attributesGrid.create: {
                    Utils.eventDispatcher(action.args.event, {
                        data: businessObject,
                        withNewRow: action.args.withNewRow,
                        id: action.payload.id,
                    });
                }
            }
        }
            return state;
        case actions.CREATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR:
            return state;
        //.....................................................................................................................

        //UPDATE_BUSINESS_OBJECT_ATTRIBUTE.....................................................................................
        case actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING:
            return state;
        case actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS: {
            switch (action.payload.type) {
                case AttributeTypeEnum.TIMESTAMP:
                    action.payload.defaultValue = moment(action.payload.defaultValue, moment.ISO_8601).isValid() ? moment.utc(action.payload.defaultValue).utcOffset(moment(action.payload.defaultValue).format("ZZ").toString()).format(moment(action.payload.defaultValue).creationData().format.toString()) : action.payload.defaultValue;
                    break;
                case AttributeTypeEnum.TIME:
                    const dataTime = `${moment().format("YYYY-MM-DD")} ${action.payload.defaultValue}`;
                    action.payload.defaultValue = moment(dataTime, moment.ISO_8601).isValid() ? moment.utc(dataTime).utcOffset(moment(dataTime).format("ZZ").toString()).format('HH:mm:ss') : action.payload.defaultValue;
                    break;
                case AttributeTypeEnum.EMAIL:
                    action.payload.defaultValue = Utils.parseEmailAttributeDefaultValue(action.payload.defaultValue, action.payload.attributeValues);
                    break;
            }
            const businessObject = state.businessObjectsWrapper.getBusinessObject(action.args.boClass.id);
            const attribute = businessObject.getAttribute(action.payload.id);
            attribute.update(action.payload);
            switch (action.args.event) {
                case EVENTS.boView.attributesGrid.update: {
                    Utils.eventDispatcher(action.args.event, {
                        attribute: attribute
                    });
                }
            }
        }
            return state;
        case actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR:
            return state;
        //.....................................................................................................

        //DELETE_BUSINESS_OBJECT_ATTRIBUTE.....................................................................
        case actions.DELETE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_PENDING:
            return state;
        case actions.DELETE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_SUCCESS: {
            const businessObject = state.businessObjectsWrapper.getBusinessObject(action.args.boClass.id);
            businessObject.deleteAttribute(action.id);
            switch (action.args.event) {
                case EVENTS.boView.attributesGrid.delete: {
                    Utils.eventDispatcher(action.args.event, {
                        id: action.id,
                    });
                }
            }
        }
            return state;
        case actions.DELETE_BUSINESS_OBJECT_ATTRIBUTE_RECORD_DISPATCH_ERROR:
            return state;
        //......................................................................................................

        //CREATE_BUSINESS_OBJECT_RELATIONSHIP...................................................................
        case actions.CREATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_PENDING:
            return state;
        case actions.CREATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_SUCCESS: {
            const fromBusinessObject = state.businessObjectsWrapper.getBusinessObject(action.payload.fromBoClass.id);
            const toBusinessObject = state.businessObjectsWrapper.getBusinessObject(action.payload.toBoClass.id);
            fromBusinessObject.addRelationship(new Relationship(action.payload.id, action.payload.name, action.payload.inward, action.payload.outward, action.payload.fromBoClass, action.payload.toBoClass, action.payload.systemRequired));
            toBusinessObject.addRelationship(new Relationship(action.payload.id, action.payload.name, action.payload.inward, action.payload.outward, action.payload.fromBoClass, action.payload.toBoClass, action.payload.systemRequired));
            state.hiddenAndModifiedBOCsForLayout = [];
            switch (action.args.event) {
                case EVENTS.boView.relationshipsGrid.create: {
                    setTimeout(() => {
                        Utils.eventDispatcher(action.args.event, {
                            businessObject: fromBusinessObject,
                            withNewRow: action.args.withNewRow,
                            id: action.payload.id,
                        });
                    });
                }
            }
        }
            return state;
        case actions.CREATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_ERROR:
            return state;
        //........................................................................................................

        //UPDATE_BUSINESS_OBJECT_RELATIONSHIP......................................................................
        case actions.UPDATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_PENDING:
            return state;
        case actions.UPDATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_SUCCESS: {
            const fromBusinessObject = state.businessObjectsWrapper.getBusinessObject(action.payload.fromBoClass.id);
            const toBusinessObject = state.businessObjectsWrapper.getBusinessObject(action.payload.toBoClass.id);
            const fromRelationship = fromBusinessObject.getRelationship(action.payload.id);
            fromRelationship.name = action.payload.name;
            fromRelationship.inward = action.payload.inward;
            fromRelationship.outward = action.payload.outward;
            fromRelationship.toBoClass = action.payload.toBoClass;
            fromRelationship.fromBoClass = action.payload.fromBoClass;
            fromRelationship.systemRequired = action.payload.systemRequired;

            const toRelationship = toBusinessObject.getRelationship(action.payload.id);
            toRelationship.name = action.payload.name;
            toRelationship.inward = action.payload.inward;
            toRelationship.outward = action.payload.outward;
            toRelationship.toBoClass = action.payload.toBoClass;
            toRelationship.fromBoClass = action.payload.fromBoClass;
            toRelationship.systemRequired = action.payload.systemRequired;
            state.hiddenAndModifiedBOCsForLayout = [];
            switch (action.args.event) {
                case EVENTS.boView.relationshipsGrid.update: {
                    Utils.eventDispatcher(action.args.event, {
                        relationship: fromRelationship
                    });
                }
            }
        }
            return state;
        case actions.UPDATE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_ERROR:
            return state;
        //....................................................................................................

        //DELETE_BUSINESS_OBJECT_RELATIONSHIP.................................................................
        case actions.DELETE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_PENDING:
            return state;
        case actions.DELETE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_SUCCESS: {
            const fromBusinessObject = state.businessObjectsWrapper.getBusinessObject(action.args.fromBoClass.id);
            const toBusinessObject = state.businessObjectsWrapper.getBusinessObject(action.args.toBoClass.id);
            fromBusinessObject.deleteRelationship(action.id);
            toBusinessObject.deleteRelationship(action.id);
            state.hiddenAndModifiedBOCsForLayout = [];
            switch (action.args.event) {
                case EVENTS.boView.relationshipsGrid.delete: {
                    Utils.eventDispatcher(action.args.event, {
                        id: action.id,
                    });
                }
            }
        }
            return state;
        case actions.DELETE_BUSINESS_OBJECT_RELATIONSHIP_RECORD_DISPATCH_ERROR:
            return state;
        //...............................................................................................................

        //CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE.........................................................................
        case actions.CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_PENDING:
            return state;
        case actions.CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_SUCCESS: {
            const businessObject = state.businessObjectsWrapper.getBusinessObject(action.args.boClass.id);
            const attribute = businessObject.getAttribute(action.args.attribute.id);
            attribute.setAttributeValues(action.payload);
            if (action.args.event === EVENTS.boView.valueListGrid.create) {
                setTimeout(() => {
                    Utils.eventDispatcher(action.args.event, {
                        name: action.name,
                        attribute: attribute,
                        withNewRow: action.args.withNewRow
                    });
                });
            }
        }
            return state;
        case actions.CREATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_ERROR:
            return state;
        //.................................................................................................................

        //UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE...........................................................................
        case actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_PENDING:
            return state;
        case actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_SUCCESS: {
            const businessObject = state.businessObjectsWrapper.getBusinessObject(action.args.boClass.id);
            const attribute = businessObject.getAttribute(action.args.attribute.id);
            attribute.setAttributeValue(action.payload);
            if (action.args.event === EVENTS.boView.valueListGrid.update) {
                setTimeout(() => {
                    Utils.eventDispatcher(action.args.event, {
                        attributeValue: action.payload
                    })
                });
            }
        }
            return state;
        case actions.UPDATE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_ERROR:
            return state;
        //...............................................................................................................

        //DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE.........................................................................
        case actions.DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_PENDING:
            return state;
        case actions.DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_SUCCESS: {
            const businessObject = state.businessObjectsWrapper.getBusinessObject(action.args.bocId);
            const attribute = businessObject.getAttribute(action.args.attributeId);
            attribute.deleteValueListItem(action.args.attributeValueId);

            if (action.args.event === EVENTS.boView.valueListGrid.delete) {
                setTimeout(() => {
                    Utils.eventDispatcher(action.args.event, {
                        data: action.args
                    })
                });
            }
        }
            return state;
        case actions.DELETE_BUSINESS_OBJECT_ATTRIBUTE_VALUE_RECORD_DISPATCH_ERROR:
            return state;
        //...............................................................................................


        //FETCH BO INSTANCE................................................................................
        case actions.FETCH_BO_INSTANCE_BY_ID_PENDING:
            return state;
        case actions.FETCH_BO_INSTANCE_BY_ID_DISPATCH_SUCCESS: {
            action.payload.attributes = instanceAttribNormalization(action.payload.attributes);
            Utils.eventDispatcher(EVENTS.editForm.setCurrentInstance, {
                currentInstance: new Instance(action.payload.id, action.payload.name, action.payload.boClass, action.payload.attributes || [], action.payload.relationships || [], action.payload.tags || [], moment.utc(action.payload.created).utcOffset(moment(action.payload.created).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), moment.utc(action.payload.updated).utcOffset(moment(action.payload.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), action.payload.updatedByUser),
                setOriginalInstance: true
            });
        }
            return state;
        case actions.FETCH_BO_INSTANCE_BY_ID_DISPATCH_ERROR:
            return state;
        //..................................................................................................


        //CREATE BO INSTANCE................................................................................
        case actions.CREATE_BO_INSTANCE_PENDING:
            return state;
        case actions.CREATE_BO_INSTANCE_DISPATCH_SUCCESS: {
            const tags = action.payload.tags;
            tags.forEach(tag => {
                if (!state.tagsSet.has(tag)) {
                    state.tagsSet.add(tag);
                }
            });
            action.payload.attributes = instanceAttribNormalization(action.payload.attributes || []);
            const newInstance = new Instance(action.payload.id, action.payload.name, action.payload.boClass, action.payload.attributes, action.payload.relationships || [], action.payload.tags || [], moment.utc(action.payload.created).utcOffset(moment(action.payload.created).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), moment.utc(action.payload.updated).utcOffset(moment(action.payload.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), action.payload.updatedByUser);

            Utils.eventDispatcher(EVENTS.editForm.setCurrentInstance, {
                currentInstance: newInstance,
                setOriginalInstance: true
            });
        }
            return state;
        case actions.CREATE_BO_INSTANCE_DISPATCH_ERROR:
            return state;
        //.................................................................................................

        //CREATE LAYOUT BO INSTANCE................................................................................
        case actions.CREATE_BO_INSTANCE_LAYOUT_PENDING:
            return state;
        case actions.CREATE_BO_INSTANCE_LAYOUT_DISPATCH_SUCCESS: {
            action.payload.attributes = instanceAttribNormalization(action.payload.attributes || []);
            const newLayout = new Instance(action.payload.id, action.payload.name, action.payload.boClass, action.payload.attributes || [], action.payload.relationships || [], action.payload.tags || [], moment.utc(action.payload.created).utcOffset(moment(action.payload.created).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), moment.utc(action.payload.updated).utcOffset(moment(action.payload.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), action.payload.updatedByUser);
            Utils.eventDispatcher(EVENTS.boInstance.instanceLayout.createLayout, {
                newLayout: newLayout
            });
        }
            return state;
        case actions.CREATE_BO_INSTANCE_LAYOUT_DISPATCH_ERROR:
            return state;
        //.................................................................................................


        //UPDATE BO INSTANCE................................................................................
        case actions.UPDATE_BO_INSTANCE_PENDING:
            return state;
        case actions.UPDATE_BO_INSTANCE_DISPATCH_SUCCESS: {
            const tags = action.payload.data.tags;
            tags.forEach(tag => {
                if (!state.tagsSet.has(tag)) {
                    state.tagsSet.add(tag);
                }
            });

            action.payload.data.attributes = instanceAttribNormalization(action.payload.data.attributes || []);
            const newInstance = new Instance(action.payload.data.id, action.payload.data.name, action.payload.data.boClass, action.payload.data.attributes, action.payload.data.relationships || [], action.payload.data.tags || [], moment.utc(action.payload.data.created).utcOffset(moment(action.payload.data.created).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), moment.utc(action.payload.data.updated).utcOffset(moment(action.payload.data.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), action.payload.data.updatedByUser);
            Utils.eventDispatcher(EVENTS.editForm.setCurrentInstance, {
                currentInstance: newInstance,
                setOriginalInstance: true
            });
        }
            return state;
        case actions.UPDATE_BO_INSTANCE_DISPATCH_ERROR:
            return state;
        //.....................................................................................................

        //UPDATE BO INSTANCE LAYOUT................................................................................
        case actions.UPDATE_BO_INSTANCE_LAYOUT_PENDING:
            return state;
        case actions.UPDATE_BO_INSTANCE_LAYOUT_DISPATCH_SUCCESS: {
            action.payload.attributes = instanceAttribNormalization(action.payload.attributes || []);
            const newLayout = new Instance(action.payload.id, action.payload.name, action.payload.boClass, action.payload.attributes || [], action.payload.relationships || [], action.payload.tags || [], moment.utc(action.payload.created).utcOffset(moment(action.payload.created).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), moment.utc(action.payload.updated).utcOffset(moment(action.payload.updated).format("ZZ").toString()).format('YYYY-MM-DD HH:mm:ss'), action.payload.updatedByUser);

            Utils.eventDispatcher(EVENTS.boInstance.instanceLayout.updateLayout, {
                newLayout: newLayout
            });
        }
            return state;
        case actions.UPDATE_BO_INSTANCE_LAYOUT_DISPATCH_ERROR:
            return state;
        //.....................................................................................................

        //CREATE BO INSTANCE RELATIONSHIP......................................................................
        case actions.CREATE_BO_INSTANCE_RELATIONSHIP_PENDING:
            return state;
        case actions.CREATE_BO_INSTANCE_RELATIONSHIP_DISPATCH_SUCCESS:
            Utils.eventDispatcher(EVENTS.editForm.addInstanceRelationship, {
                relationships: action.payload
            });
            return state;
        case actions.CREATE_BO_INSTANCE_RELATIONSHIP_DISPATCH_ERROR:
            return state;
        //.......................................................................................................

        //DELETE BO INSTANCE RELATIONSHIP......................................................................
        case actions.DELETE_BO_INSTANCE_RELATIONSHIP_PENDING:
            return state;
        case actions.DELETE_BO_INSTANCE_RELATIONSHIP_DISPATCH_SUCCESS:
            Utils.eventDispatcher(EVENTS.editForm.deleteInstanceRelationship, {
                items: action.payload
            });
            return state;
        case actions.DELETE_BO_INSTANCE_RELATIONSHIP_DISPATCH_ERROR:
            return state;
        //.......................................................................................................

        //UPDATE BO INSTANCE TAGS................................................................................
        case actions.UPDATE_BO_INSTANCE_TAGS_PENDING:
            return state;
        case actions.UPDATE_BO_INSTANCE_TAGS_DISPATCH_SUCCESS : {
            Utils.eventDispatcher(EVENTS.editForm.updateInstanceTags, {
                tags: action.payload.data
            });
        }
            return state;
        case actions.UPDATE_BO_INSTANCE_TAGS_DISPATCH_ERROR :
            return state;
        //.................................................................................................

        //DELETE BO INSTANCE................................................................................
        case actions.DELETE_BO_INSTANCE_PENDING :
            return state;
        case actions.DELETE_BO_INSTANCE_DISPATCH_SUCCESS:
            return state;
        case actions.DELETE_BO_INSTANCE_DISPATCH_ERROR :
            return state;
        //.................................................................................................

        //FETCH ALL  DATA VIEWS............................................................................
        case actions.FETCH_ALL_DATA_VIEWS_PENDING:
            state.dataViewsWrapper = <DataViewWrapper>null;
            return state;
        case actions.FETCH_ALL_DATA_VIEWS_DISPATCH_SUCCESS: {
            state.dataViewsWrapper = new DataViewWrapper(action.payload);
        }
            return state;
        case actions.FETCH_ALL_DATA_VIEWS_DISPATCH_ERROR:
            return state;
        //.................................................................................................

        //FETCH ALL  DATA VIEWS BY BOC ID..................................................................
        case actions.FETCH_ALL_DATA_VIEWS_BY_BOC_ID_PENDING:
            state.dataViewsWrapper = <DataViewWrapper>null;
            return state;
        case actions.FETCH_ALL_DATA_VIEWS_BY_BOC_ID_SUCCESS: {
            state.dataViewsWrapper = <DataViewWrapper>new DataViewWrapper(action.payload);
        }
            return state;
        case actions.FETCH_ALL_DATA_VIEWS_BY_BOC_ID_ERROR:
            return state;
        //.................................................................................................

        //CREATE DATA VIEW.................................................................................
        case actions.CREATE_DATA_VIEW_PENDING:
            return state;
        case actions.CREATE_DATA_VIEW_DISPATCH_SUCCESS: {
            action.payload.columns = action.payload.column || [];
            state.dataViewsWrapper.addDataView(action.payload);
            state.dataViewsWrapper.setDefaultDataViewByBocId(action.payload.businessObjectClass.id, action.args.defaultViewName);
            switch (action.args.event) {
                case EVENTS.dataViewConfiguration.createDataView: {
                    DataViewConfiguration.eventDispatcher(action.args.event, {
                        dataViewsWrapper: state.dataViewsWrapper
                    })
                }
            }
        }
            return state;
        case actions.CREATE_DATA_VIEW_DISPATCH_ERROR:
            return state;
        //.................................................................................................

        //SET-CURRENT-DATA-VIEW............................................................................
        case actions.SET_CURRENT_DATA_VIEW:
            state.currentDataView = action.payload
            return state;
        //.................................................................................................
        //CLONE DATA VIEW..................................................................................
        case actions.CLONE_DATA_VIEW_PENDING:
            return state;
        case actions.CLONE_DATA_VIEW_DISPATCH_SUCCESS: {

        }
            return state;
        case actions.CLONE_DATA_VIEW_DISPATCH_ERROR:
            return state;
        //.................................................................................................

        //UPDATE DATA VIEW.................................................................................
        case actions.UPDATE_DATA_VIEW_PENDING:
            return state;
        case actions.UPDATE_DATA_VIEW_DISPATCH_SUCCESS: {
            state.dataViewsWrapper.deleteDataView(action.payload.id);
            state.dataViewsWrapper.addDataView(action.payload);
            state.dataViewsWrapper.setDefaultDataViewByBocId(action.payload.businessObjectClass.id, action.args.defaultViewName);

            switch (action.args.event) {
                case EVENTS.dataViewConfiguration.updateDataView: {
                    DataViewConfiguration.eventDispatcher(action.args.event, {
                        dataViewsWrapper: state.dataViewsWrapper
                    })
                }
            }
        }
            return state;
        case actions.UPDATE_DATA_VIEW_DISPATCH_ERROR:
            return state;
        //.................................................................................................

        //DELETE DATA VIEW.................................................................................
        case actions.DELETE_DATA_VIEW_PENDING:
            return state;
        case actions.DELETE_DATA_VIEW_DISPATCH_SUCCESS: {
            state.dataViewsWrapper.deleteDataView(action.id);
            state.dataViewsWrapper.setDefaultDataViewByBocId(action.args.bocId, action.args.defaultViewName);
            switch (action.args.event) {
                case EVENTS.dataViewConfiguration.deleteDataView: {
                    DataViewConfiguration.eventDispatcher(action.args.event, {
                        dataViewsWrapper: state.dataViewsWrapper
                    })
                }
            }
        }
            return state;
        case actions.DELETE_DATA_VIEW_DISPATCH_ERROR:
            return state;
        //..................................................................................................

        //CREATE COLUMNS OF  DATA VIEW......................................................................
        case actions.CREATE_COLUMNS_OF_DATA_VIEW_PENDING:
            state.columnsOfDataViewAreBeingCRUD = true;
            return state;
        case actions.CREATE_COLUMNS_OF_DATA_VIEW_DISPATCH_SUCCESS: {
            state.dataViewsWrapper.deleteDataView(action.payload.id);
            state.dataViewsWrapper.addDataView(action.payload);
            setTimeout(() => {
                Utils.eventDispatcher(EVENTS.dataViewConfiguration.updateDataViewColumns, {
                    dataViewsWrapper: state.dataViewsWrapper,
                    id: action.payload.id
                })
            });
        }
            return state;
        case actions.CREATE_COLUMNS_OF_DATA_VIEW_DISPATCH_ERROR:
            state.columnsOfDataViewAreBeingCRUD = false;
            return state;

        //FETCH ALL TAGS...............................................................................
        case actions.FETCH_ALL_TAGS_PENDING:
            state.tagsSet = <Set<string>>null;
            return state;
        case actions.FETCH_ALL_TAGS_DISPATCH_SUCCESS: {
            state.tagsSet = new Set();
            action.payload.forEach(tag => {
                state.tagsSet.add(tag)
            });
        }
            return state;
        case actions.FETCH_ALL_TAGS_DISPATCH_ERROR:
            return state;
        //..................................................................................................

        //FETCH ALL LAYOUTS...............................................................................
        case actions.FETCH_ALL_BOC_LAYOUTS_PENDING :
            return state;
        case actions.FETCH_ALL_BOC_LAYOUTS_SUCCESS:
            state.allLayouts = generateLayoutsDictionary(action.payload);
            Utils.eventDispatcher(EVENTS.boView.objectsLayout.fetchAll, {
                allLayouts: state.allLayouts,
                currentLayout: state.currentLayout
            });
            return state;
        case actions.FETCH_ALL_BOC_LAYOUTS_ERROR :
            return state;
        //..................................................................................................

        //CREATE LAYOUT...............................................................................
        case actions.CREATE_BOC_LAYOUT_PENDING:
            return state;
        case actions.CREATE_BOC_LAYOUT_SUCCESS:
            state.allLayouts.set(action.payload["id"], {id: action.payload["id"], name: action.payload["name"]});
            state.currentLayout = {
                id: action.payload["id"],
                name: action.payload["name"],
                nodes: action.payload["businessObjectClassLayouts"].map(function (node) {
                    return {
                        key: node.layout.key,
                        name: node.layout.name,
                        id: node.layout.id,
                        description: node.layout.description,
                        location: node.layout.location,
                        color: node.layout.color,
                        visible: node.layout.visible,
                        shape: node.layout.shape,
                        width: node.layout.width,
                        height: node.layout.height,
                        angle: node.layout.angle,
                        fontColor: node.layout.fontColor,
                        systemRequired: node.layout.systemRequired,
                        relationships: node.layout.relationships != null ? node.layout.relationships.map(function (relationship) {
                            return {
                                id: relationship.id,
                                from: relationship.from,
                                to: relationship.to,
                                forward: relationship.forward,
                                reverse: relationship.reverse,
                                relationship_name: relationship.relationship_name,
                                routing: relationship.routing,
                                uid: relationship.uid,
                                visible: relationship.visible,
                                labelVisible: relationship.labelVisible,
                                systemRequired: relationship.systemRequired,
                                points: relationship.points
                            }
                        }) : []
                    }
                }),

            };
            Utils.eventDispatcher(EVENTS.boView.objectsLayout.create, {
                allLayouts: state.allLayouts,
                currentLayout: state.currentLayout
            });
            return state;
        case actions.CREATE_BOC_LAYOUT_ERROR:
            return state;
        //..................................................................................................

        //FETCH LAYOUT BY ID...............................................................................
        case actions.FETCH_BOC_LAYOUT_BY_ID_PENDING:
            return state;
        case actions.FETCH_BOC_LAYOUT_BY_ID_SUCCESS:
            state.currentLayout = {
                id: action.payload["id"],
                name: action.payload["name"],
                nodes: action.payload["businessObjectClassLayouts"].map(function (node) {
                    return {
                        key: node.layout.key,
                        name: node.layout.name,
                        id: node.layout.id,
                        description: node.layout.description,
                        location: node.layout.location,
                        color: node.layout.color,
                        visible: node.layout.visible,
                        shape: node.layout.shape,
                        width: node.layout.width,
                        height: node.layout.height,
                        angle: node.layout.angle,
                        fontColor: node.layout.fontColor,
                        systemRequired: node.layout.systemRequired,
                        relationships: node.layout.relationships != null ? node.layout.relationships.map(function (relationship) {
                            return {
                                id: relationship.id,
                                from: relationship.from,
                                to: relationship.to,
                                forward: relationship.forward,
                                reverse: relationship.reverse,
                                relationship_name: relationship.relationship_name,
                                routing: relationship.routing,
                                uid: relationship.uid,
                                visible: relationship.visible,
                                labelVisible: relationship.labelVisible,
                                systemRequired: relationship.systemRequired,
                                points: relationship.points
                            }
                        }) : []
                    }
                }),
            };
            return state;
        case actions.FETCH_BOC_LAYOUT_BY_ID_ERROR:
            return state;
        //..................................................................................................

        //UPDATE LAYOUT...............................................................................
        case actions.UPDATE_BOC_LAYOUT_BY_ID_PENDING:
            return state;
        case actions.UPDATE_BOC_LAYOUT_BY_ID_SUCCESS:
            state.allLayouts.delete(action.payload["id"]);
            state.allLayouts.set(action.payload["id"], {id: action.payload["id"], name: action.payload["name"]});
            state.currentLayout = {
                id: action.payload["id"],
                name: action.payload["name"],
                nodes: action.payload["businessObjectClassLayouts"].map(function (node) {
                    return {
                        key: node.layout.key,
                        name: node.layout.name,
                        id: node.layout.id,
                        description: node.layout.description,
                        location: node.layout.location,
                        color: node.layout.color,
                        visible: node.layout.visible,
                        shape: node.layout.shape,
                        width: node.layout.width,
                        height: node.layout.height,
                        angle: node.layout.angle,
                        fontColor: node.layout.fontColor,
                        systemRequired: node.layout.systemRequired,
                        relationships: node.layout.relationships != null ? node.layout.relationships.map(function (relationship) {
                            return {
                                id: relationship.id,
                                from: relationship.from,
                                to: relationship.to,
                                forward: relationship.forward,
                                reverse: relationship.reverse,
                                relationship_name: relationship.relationship_name,
                                routing: relationship.routing,
                                uid: relationship.uid,
                                visible: relationship.visible,
                                labelVisible: relationship.labelVisible,
                                systemRequired: relationship.systemRequired,
                                points: relationship.points
                            }
                        }) : []
                    }
                })
            };
            Utils.eventDispatcher(EVENTS.boView.objectsLayout.update, {
                allLayouts: state.allLayouts,
                currentLayout: state.currentLayout
            });
            return state;
        case actions.UPDATE_BOC_LAYOUT_BY_ID_ERROR:
            return state;
        //..................................................................................................

        //DELETE LAYOUT...............................................................................
        case actions.DELETE_BOC_LAYOUT_BY_ID_PENDING:
            return state;
        case actions.DELETE_BOC_LAYOUT_BY_ID_SUCCESS:
            state.allLayouts.delete(action.payload);
            state.currentLayout = null;
            Utils.eventDispatcher(EVENTS.boView.objectsLayout.delete, {
                allLayouts: state.allLayouts,
                currentLayout: state.currentLayout
            });
            return state;
        case actions.DELETE_BOC_LAYOUT_BY_ID_ERROR:
            return state;
        //..................................................................................................

        //SET CURRENT LAYOUT...............................................................................
        case actions.SET_CURRENT_BOC_LAYOUT:
            if (action.payload != null) {
                state.currentLayout = action.payload.map(layoutModel => {
                    return {
                        id: layoutModel.id,
                        name: layoutModel.name,
                        nodes: layoutModel.businessObjectClassLayouts.map(bocLayout => {
                            return {
                                id: bocLayout.layout.id,
                                key: bocLayout.layout.key,
                                color: bocLayout.layout.color,
                                text: bocLayout.layout.text,
                                description: bocLayout.layout.description,
                                location: bocLayout.layout.location,
                                visible: bocLayout.layout.visible,
                                shape: bocLayout.layout.shape,
                                height: bocLayout.layout.height,
                                width: bocLayout.layout.width,
                                angle: bocLayout.layout.angle,
                                fontColor: bocLayout.layout.fontColor,
                                systemRequired: bocLayout.layout.systemRequired,
                                relationships: bocLayout.layout.relationships != null ? bocLayout.layout.relationships.map(function (relationship) {
                                    return {
                                        id: relationship.id,
                                        from: relationship.from,
                                        to: relationship.to,
                                        forward: relationship.forward,
                                        reverse: relationship.reverse,
                                        relationship_name: relationship.relationship_name,
                                        routing: relationship.routing,
                                        uid: relationship.uid,
                                        visible: relationship.visible,
                                        labelVisible: relationship.labelVisible,
                                        systemRequired: relationship.systemRequired,
                                        points: relationship.points
                                    }
                                }) : []
                            };
                        }),

                    };
                });
            } else {
                state.currentLayout = null;
            }

            return state;
        //..............................................................................

        case actions.SET_HIDDEN_AND_MODIFIED_BOCS_FOR_LAYOUT:
            state.hiddenAndModifiedBOCsForLayout = Array.from(action.payload);
            Utils.eventDispatcher(EVENTS.boView.objectsLayout.hidden, {
                hiddenAndModifiedBOCsForLayout: state.hiddenAndModifiedBOCsForLayout,
            });
            return state;
        case actions.UPDATE_BOC_IN_LAYOUT:
            if (action.payload != null) {
                state.updateBOCsInLayout = action.payload;
                action.payload.forEach(boc => {
                    state.hiddenAndModifiedBOCsForLayout = state.hiddenAndModifiedBOCsForLayout.splice(boc, 1);
                });
            }
            return state;
        //..........................................................................
        case actions.LAYOUT_SAVE_OBJECTS_PENDING:
            return state;
        case actions.LAYOUT_SAVE_OBJECTS_SUCCESS:
            let created = {boc: action.payload.create.succeeded.boc, relType: action.payload.create.succeeded.relType};
            let updated = {boc: action.payload.update.succeeded.boc, relType: action.payload.update.succeeded.relType};
            let deletedBoc = [];
            action.payload.delete.succeeded.boc.forEach(b => {
                deletedBoc.push(b.id);
            });
            let deleted = {boc: deletedBoc, relType: action.payload.delete.succeeded.relType};
            state.businessObjectsWrapper.updateBusinessObjectsAndRelationships(created, updated, deleted);
            Utils.eventDispatcher(EVENTS.boView.objectsLayout.saveObjects, {
                businessObjectsWrapper: state.businessObjectsWrapper,
            });

            return state;
        case actions.LAYOUT_SAVE_OBJECTS_ERROR:
            return state;
        default:
        case actions.FETCH_PARTS_TO_COMPARE_PENDING:
            return state;
        case actions.FETCH_PARTS_TO_COMPARE_DISPATCH_SUCCESS: {
            Utils.eventDispatcher(EVENTS.partsToCompare.compare, {
                partsToCompare: generatePartsToCompareData(action.payload)
            });
        }
            return state;
        case actions.FETCH_PARTS_TO_COMPARE_DISPATCH_ERROR:
            return state;
        //..............................................................................
    }
}

const generateLayoutsDictionary = (data) => {
    let map = new Map();
    data.forEach(layout => {
        let id = layout.id;
        map.set(id, {id: layout.id, name: layout.name});
    });
    return map;
};

const getRelationshipsForTopInstance = (data, relationships, index) => {
    if (data.relationships) {
        data.relationships.forEach(rel => {
            relationships.push({
                order: rel.order,
                relType: rel.relType,
                value: Array.from(rel.value.values()),
                layer: index,
                total: rel.totalRelationshipsCount
            });
            rel.value.forEach(val => {
                if (val.fromBoInstance.relationships != null && val.fromBoInstance.relationships.length > 0) {
                    getRelationshipsForTopInstance(val.fromBoInstance, relationships, (index + 1));
                }
                if (val.toBoInstance.relationships != null && val.toBoInstance.relationships.length > 0) {
                    getRelationshipsForTopInstance(val.toBoInstance, relationships, (index + 1));
                }
            });
        });
    } else {
        relationships.push({
            order: data.order,
            relType: data.relType,
            value: Array.from(data.value.values()),
            layer: index,
            total: data.totalRelationshipsCount
        });
        data.value.forEach(val => {
            if (val.fromBoInstance.relationships != null && val.fromBoInstance.relationships.length > 0) {
                getRelationshipsForTopInstance(val.fromBoInstance, relationships, (index + 1));
            }
            if (val.toBoInstance.relationships != null && val.toBoInstance.relationships.length > 0) {
                getRelationshipsForTopInstance(val.toBoInstance, relationships, (index + 1));
            }
        });
    }

};

// @ts-ignore
const generatePartsToCompareData = (res) => {
    let columns = [], data = [];
    try {
        const metrics = res.metrics;
        const parts = res.parts;

        metrics.columns.forEach(name => {
            columns.push({
                type: {id: null, name: "Metric"},
                name: name,
            });
        });

        parts.columns.forEach(col => {
            columns.push({
                type: col.company ? col.company : {id: null, name: "n/a"},
                name: col.name,
            })
        });

        for (let i in metrics.content) {
            data.push(metrics.content[i].concat(parts.content[i]));
        }
    } catch (e) {
        console.error(e);
        return {columns: [], data: []}
    }
    return {columns, data}
};


function instanceAttribNormalization<T extends { attribute: AttributeInterface, value: any }[]>(attributes: T): T {
    attributes.forEach(item => {
        switch (item.attribute.type) {
            case AttributeTypeEnum.TIMESTAMP:
                item.value = moment(item.value, moment.ISO_8601).isValid() ? moment.utc(item.value).utcOffset(moment(item.value).format("ZZ").toString()).format(moment(item.value).creationData().format.toString()) : item.value;
                break;
            case AttributeTypeEnum.TIME:
                const dataTime = `${moment().format("YYYY-MM-DD")} ${item.value}`;
                item.value = moment(dataTime, moment.ISO_8601).isValid() ? moment.utc(dataTime).utcOffset(moment(dataTime).format("ZZ").toString()).format('HH:mm:ss') : item.value;
                break;
        }
    });
    return attributes;
}


// WEBPACK FOOTER //
// ./app/reducers/boCore.ts